import { __decorate } from "tslib";
import { Sim } from '@dooboostore/simple-boot';
export var GpuRentalService;
(function (GpuRentalService) {
    GpuRentalService.SYMBOL = Symbol.for('GpuRentalService');
})(GpuRentalService || (GpuRentalService = {}));
export default (container) => {
    let GpuRentalServiceImpl = class GpuRentalServiceImpl {
        constructor() {
            Object.defineProperty(this, "CORS_PROXY", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://sparkling-dew-b13c.visualkhh.workers.dev/?url='
            });
        }
        async fetchJson(url) {
            const res = await fetch(`${this.CORS_PROXY}${encodeURIComponent(url)}`, {
                headers: { accept: 'application/json' },
            });
            if (!res.ok)
                throw new Error(`HTTP ${res.status}`);
            return (await res.json());
        }
        async getPriceHistory() {
            const json = await this.fetchJson('https://storage.googleapis.com/vast-public-gpu-pricing/gpu-pricing-public.json');
            const gpus = json?.gpus ?? {};
            const out = {};
            for (const [slug, g] of Object.entries(gpus)) {
                const name = String(g?.name ?? slug);
                const daily = Array.isArray(g?.daily) ? g.daily : [];
                const cur = g?.current ?? {};
                out[name] = {
                    name,
                    vramGb: g?.vram_gb ?? null,
                    tier: String(g?.tier ?? ''),
                    available: Number(g?.available ?? cur?.available ?? 0),
                    curMin: Number(cur?.min ?? 0),
                    curMedian: Number(cur?.median ?? 0),
                    daily: daily
                        .filter(d => d && d.date && Number.isFinite(Number(d.median)))
                        .map(d => ({ date: String(d.date), median: Number(d.median) }))
                        .sort((a, b) => a.date.localeCompare(b.date)),
                };
            }
            return out;
        }
    };
    GpuRentalServiceImpl = __decorate([
        Sim({ symbol: GpuRentalService.SYMBOL, container })
    ], GpuRentalServiceImpl);
    return GpuRentalServiceImpl;
};
